// Define interface for params object
export interface RequestParams {
  query?: string;
  page?: number;
  size?: number;
}

const ZERO_DECIMAL_CURRENCIES = new Set([
  'BIF', 'CLP', 'DJF', 'GNF', 'JPY', 'KMF', 'KRW', 'MGA',
  'PYG', 'RWF', 'UGX', 'VND', 'VUV', 'XAF', 'XOF', 'XPF'
]);

export function moneyFormatter(amount: number, currency?: string): string {
  if (currency && ZERO_DECIMAL_CURRENCIES.has(currency.toUpperCase())) {
    return Number(amount).toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }
  return (Number(amount) / 100).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

export function getRequestParams(searchQuery?: string, page?: number, pageSize?: number): RequestParams {
  const params: RequestParams = {};

  if (searchQuery) {
    params.query = searchQuery;
  }

  if (page) {
    params.page = page - 1;
  }

  if (pageSize) {
    params.size = pageSize;
  }

  return params;
}

export function a11yProps(index: number): {
  id: string;
  'aria-controls': string;
} {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}
